export default __webpack_public_path__ + "static/media/missouri.da911a1d.jpg";